import React, { useCallback, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { RecordImage, RecordImageModal } from '../../../react/components/molecules/recordImageModal';

// 記録の行（records/_record_row の data-record-image 付き button）をタップしたら、
// その記録の答案画像をモーダルで出す。「成績」タブの最近の記録と記録一覧ページで共用する。
const rootId = 'react-record-image-modal';
const triggerSelector = '[data-record-image]';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById(rootId);
  if (root == null) return;

  const RecordImageModalRoot: React.FC = () => {
    const [image, setImage] = useState<RecordImage | null>(null);

    useLayoutEffect(() => {
      const triggers = Array.from(document.querySelectorAll<HTMLButtonElement>(triggerSelector));
      const listeners = triggers.map((trigger) => {
        const listener = () => {
          const { imageUrl, imageTitle, imageCaption } = trigger.dataset;
          if (imageUrl == null) return;

          setImage({ url: imageUrl, title: imageTitle ?? '', caption: imageCaption ?? '' });
        };
        trigger.addEventListener('click', listener);
        return { trigger, listener };
      });

      return () => {
        listeners.forEach(({ trigger, listener }) => trigger.removeEventListener('click', listener));
      };
    }, []);

    const close = useCallback(() => setImage(null), []);

    if (image == null) return null;

    return <RecordImageModal image={image} onClose={close} />;
  };

  ReactDOM.render(<RecordImageModalRoot />, root);
});
